var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"newEmailCampaignContainer"}},[_c('email-campaign',{attrs:{"email-campaign-id":this.$route.params.id},on:{"save":_vm.handleOnSave,"cancel":_vm.handleCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }